(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/immutable.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/immutable.js');
"use strict";


const updateArray = (row, valueCallback) => row.map((currentValue, currentIndex) => valueCallback(currentValue, currentIndex));
const updateArrayIndex = (row, index, valueCallback) => updateArray(row, (currentValue, currentIndex) => currentIndex === index ? valueCallback(currentValue) : currentValue);
svs.racing.gameEngine.utils.immutable = {
  updateArray,
  updateArrayIndex
};

 })(window);